module.exports = __webpack_public_path__ + "img/2025-01-09d_1.7aa242c2.jpg";